module.exports = __webpack_public_path__ + "img/13.91ef8a67.png";